import { render, staticRenderFns } from "./SupplierOnboardingCreditScore.vue?vue&type=template&id=87798730&"
import script from "./SupplierOnboardingCreditScore.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingCreditScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports